import Avatar from "@components/profile/avatar";
import { IAgoraRTCRemoteUser, ICameraVideoTrack, ILocalVideoTrack } from "agora-rtc-sdk-ng";
import VideoPlayer from "../Videos/VideoPlayer";
import { useCallback, useEffect, useState } from "react";

interface IUserVideoDisplayProps {
    username: string,
    size: number,
    user?: IAgoraRTCRemoteUser,
    roleCode?: "PR" | "PA"
    track?: ILocalVideoTrack | ICameraVideoTrack
    onClick?: (username: string) => void,
    userSelected?: string
}
/**
 * @abstract Component thant handles each user's videocall member to show it's video track or their Avatar
 */
//TODO Remove Avatar component imported from SaludProx and use the videocall/lib/Avatar
const UserVideoDisplay = (props: IUserVideoDisplayProps) => {
    const { username, size, user, track, roleCode, userSelected } = props;

    const [isSelected, setIsSelected] = useState<boolean>(false)

    useEffect(() => {
        setIsSelected(typeof userSelected === "string" && userSelected === username)
    }, [userSelected, username])

    const selectUser = () => {
        if(props.onClick)
            props.onClick(username)
    }

    /**
     * Determines which class to use based on selection
     */
    const getClassName = useCallback(() => {
        if(isSelected) return "VideoCall__VideoLayout-Selected" 
        else return "VideoCall__VideoLayout"
    }, [isSelected])
    
    return (
        <div className={getClassName()}
            onClick={selectUser}>
            {
                !user?.videoTrack && track?.enabled && !track?.muted ?
                <VideoPlayer className="vid"
                    videoTrack={track}
                    style={{ height: "100%", width: "100%" }} />
                :
                !user || !user.videoTrack ?
                <div className="VideoCall__Avatar"
                    style={{minHeight: '150px', minWidth: '150px'}}
                >
                    <Avatar
                        username={username}
                        roleCode={roleCode || "PA"}
                        size={size}
                        editable={false} />
                    <div className="VideoCall__MiniInfoName">
                        <em className="fas fa-user" />
                        <p className="VideoCall__MiniInfoNameText"> {username} </p>
                    </div>
                </div>
                :
                <VideoPlayer className="vid"
                    videoTrack={user.videoTrack}
                    style={{ height: "100%", width: "100%" }} />
            }
        </div>
    )
}

export default UserVideoDisplay;
